import { render, staticRenderFns } from "./RegSelect.vue?vue&type=template&id=6399054a&scoped=true&"
import script from "./RegSelect.vue?vue&type=script&lang=js&"
export * from "./RegSelect.vue?vue&type=script&lang=js&"
import style0 from "./RegSelect.vue?vue&type=style&index=0&id=6399054a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6399054a",
  null
  
)

export default component.exports